import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SearchResult } from 'src/domain/searchResults/searchResult';
import { map } from 'rxjs/operators';

import { Observable } from 'rxjs';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  endpoint = this.globalService.endpoint;

  tokenValid: boolean;

  constructor(private http: HttpClient, public authService: AuthService, public router: Router, private globalService: GlobalService) {}

  getHeaders() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization:'Bearer ' +  localStorage.getItem('login_token')
    });
  }

  

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

   
    if((this.globalService.loggedUser.id_role==96)&&(next.url.length==0)){
      this.router.navigateByUrl("/dashboard/surveys/surveys");
      return false;
    }

    return true;
  
    
    const url = this.endpoint + 'auth/tokenisvalid';
    const params = {};

    return this.http.post<any>(url, params, {headers: this.getHeaders()}).pipe(map(result => {
    
      
      if (result.Result === 'OK') {    
        return true;    
        if (next.data.role) {
          if (this.globalService.permits.includes(next.data.role)) {
            return true;
          } else {
            this.router.navigate(['/dashboard']);
            return false;
          }
        } else {
          return true;
        }
      }

      // navigate to not found page
      this.router.navigate(['']);
      return false;
    }));
  }

  isTokenValidNew(): any {
    const url = this.endpoint + 'auth/tokenisvalid';
    return true;
    const params = {};
    return this.http.post<any>(url, params, {headers: this.getHeaders()}).subscribe(data => {
      if (!this.authService.loggedIn) {
        this.authService.logout();
        this.router.navigate(['']).then(() => {
          window.location.reload();
        });;
        return false;
      }
      return true;
    }, error => {
      this.authService.logout();
      this.router.navigate(['']).then(() => {
        window.location.reload();
      });;
      return false;
    });
  }

}
